export default {"src":"/_next/static/media/link.e3f65b1f.svg","height":800,"width":800};